import * as ambassadorWixRestaurantsOrderPacingV1Policy from './restaurants-order-pacing-v1-policy-order-pacing-policy.http.js';
import * as ambassadorWixRestaurantsOrderPacingV1PolicyTypes from './restaurants-order-pacing-v1-policy-order-pacing-policy.types.js';
import * as ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes from './restaurants-order-pacing-v1-policy-order-pacing-policy.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPolicy(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes.CreatePolicyRequest,
  ambassadorWixRestaurantsOrderPacingV1PolicyTypes.CreatePolicyRequest,
  ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes.CreatePolicyResponse,
  ambassadorWixRestaurantsOrderPacingV1PolicyTypes.CreatePolicyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOrderPacingV1Policy.createPolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/policies',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPolicy(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes.GetPolicyRequest,
  ambassadorWixRestaurantsOrderPacingV1PolicyTypes.GetPolicyRequest,
  ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes.GetPolicyResponse,
  ambassadorWixRestaurantsOrderPacingV1PolicyTypes.GetPolicyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOrderPacingV1Policy.getPolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/policies',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePolicy(): __PublicMethodMetaInfo<
  'POST',
  { policyId: string },
  ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes.UpdatePolicyRequest,
  ambassadorWixRestaurantsOrderPacingV1PolicyTypes.UpdatePolicyRequest,
  ambassadorWixRestaurantsOrderPacingV1PolicyUniversalTypes.UpdatePolicyResponse,
  ambassadorWixRestaurantsOrderPacingV1PolicyTypes.UpdatePolicyResponse
> {
  const payload = { policy: { id: ':policyId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOrderPacingV1Policy.updatePolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/policies/{policy.id}',
    pathParams: { policyId: 'policyId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
